export default "__VITE_ASSET__CdWYHB0T__"